/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateClientRequest
 */
export interface UpdateClientRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateClientRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientRequest
     */
    sso_domain?: string | null;
}

/**
 * Check if a given object implements the UpdateClientRequest interface.
 */
export function instanceOfUpdateClientRequest(value: object): value is UpdateClientRequest {
    return true;
}

export function UpdateClientRequestFromJSON(json: any): UpdateClientRequest {
    return UpdateClientRequestFromJSONTyped(json, false);
}

export function UpdateClientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClientRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'sso_domain': json['sso_domain'] == null ? undefined : json['sso_domain'],
    };
}

export function UpdateClientRequestToJSON(json: any): UpdateClientRequest {
    return UpdateClientRequestToJSONTyped(json, false);
}

export function UpdateClientRequestToJSONTyped(value?: UpdateClientRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'sso_domain': value['sso_domain'],
    };
}

